import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar d-flex justify-content-space-between",
  "aria-label": "Navigation header"
}
const _hoisted_2 = {
  class: "d-flex flex-nowrap",
  "aria-label": "Homepage"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand navbar-light",
  href: "#"
}, "Labspace", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("footer", { class: "position-relative text-center text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© Labspace is a name owned by Steve Huguenin and cannot be used by another hacker group.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vanta = _resolveComponent("Vanta")!
  const _component_MDBIcon = _resolveComponent("MDBIcon")!
  const _component_National = _resolveComponent("National")!
  const _component_Content = _resolveComponent("Content")!
  const _component_Form = _resolveComponent("Form")!
  const _component_MediaBar = _resolveComponent("MediaBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Vanta),
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_MDBIcon, {
          icon: "tools",
          size: "2x",
          iconStyle: "fas"
        }),
        _hoisted_3
      ]),
      _createVNode(_component_National, {
        country: _ctx.country,
        onChangeCountry: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeCountry($event))),
        onChangeLang: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang($event)))
      }, null, 8, ["country"])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_Content, { content: _ctx.content }, null, 8, ["content"]),
      _createVNode(_component_Form, { content: _ctx.content }, null, 8, ["content"]),
      _createElementVNode("aside", null, [
        _createVNode(_component_MediaBar)
      ])
    ]),
    _hoisted_4
  ], 64))
}